export const E = {
  lk: {
    authTelegram:        "/v1/lk/auth/telegram",
    authLogout:          "/v1/lk/auth/logout",
    me:                  "/v1/lk/me",
    subscriptions:       "/v1/lk/subscriptions",
    invitesRedeem:       "/v1/lk/invites/redeem",
    walletTransactions:  "/v1/lk/wallet/transactions",
    walletTopupStars:    "/v1/lk/wallet/topup/stars",
    // auth-v2 (2026-05-12): bot deeplink login + LK TOTP
    botDeeplinkStart:    "/v1/lk/auth/bot-deeplink/start",
    botDeeplinkPoll:     (code: string) => `/v1/lk/auth/bot-deeplink/poll/${encodeURIComponent(code)}`,
    totpSetup:           "/v1/lk/auth/totp/setup",
    totpVerify:          "/v1/lk/auth/totp/verify",
    totpDisable:         "/v1/lk/auth/totp/disable",
    totpBackupRegenerate:"/v1/lk/auth/totp/backup-codes/regenerate",
    botSessionExchange:  "/v1/lk/auth/bot-session-exchange",
  },
  admin: {
    authTelegram: "/v1/admin/auth/telegram",
    totpSetup:    "/v1/admin/auth/totp/setup",
    totpVerify:   "/v1/admin/auth/totp/verify",
    totpBackupRegenerate: "/v1/admin/auth/totp/backup-codes/regenerate",
    users:        "/v1/admin/users",
    userDetail:   (id: string) => `/v1/admin/users/${id}`,
    invites:      "/v1/admin/invites",
  },
} as const;
